import { __assign } from 'tslib';
import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../util/Visible/Visible.js';
import '../../buttons/index.js';
import ProcessingZoneContainer from '../components/ProcessingZone/ProcessingZoneContainer.js';
import UploadDropzoneComponent from './UploadDropzoneComponent.js';

var UploadDropzoneContainer = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'condensed' : _b, fileBrowseTitle = _a.fileBrowseTitle, dragDropTitle = _a.dragDropTitle, activeClassName = _a.activeClassName, classes = _a.classes, disabled = _a.disabled, acceptedFileTypes = _a.acceptedFileTypes, maxFileSizeBytes = _a.maxFileSizeBytes, maxFiles = _a.maxFiles, multiple = _a.multiple, files = _a.files, processingConfig = _a.processingConfig, uploadFile = _a.uploadFile, onFilesRejected = _a.onFilesRejected, customValidator = _a.customValidator;
    var areFilesUnprocessed = !!files.find(function (file) { return !file.processed && !file.error; });
    var showProcessingFlow = processingConfig && ((processingConfig === null || processingConfig === void 0 ? void 0 : processingConfig.status) === 'pending' || areFilesUnprocessed);
    var basicConfig = {
        noClick: true,
        noKeyboard: true,
        accept: acceptedFileTypes,
        maxSize: maxFileSizeBytes,
        maxFiles: maxFiles,
        validator: customValidator,
        multiple: multiple
    };
    var config = type === 'simple'
        ? __assign(__assign({}, basicConfig), { noDrag: true, maxFiles: 1, multiple: false })
        : basicConfig;
    var _c = useDropzone(config), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, open = _c.open, acceptedFiles = _c.acceptedFiles, fileRejections = _c.fileRejections, isDragActive = _c.isDragActive;
    var initialDropzoneClassName = clsx('c-dropzone', type === 'condensed' && 'c-dropzone--condensed');
    var _d = useState(initialDropzoneClassName), dropzoneClass = _d[0], setDropzoneClass = _d[1];
    useEffect(function () {
        if (isDragActive) {
            setDropzoneClass(clsx(dropzoneClass, activeClassName || 'c-dropzone--highlight'));
        }
        else {
            setDropzoneClass(initialDropzoneClassName);
        }
    }, [activeClassName, dropzoneClass, initialDropzoneClassName, isDragActive]);
    useEffect(function () {
        if (acceptedFiles.length) {
            acceptedFiles.forEach(function (file) { return uploadFile(file); });
        }
        if (fileRejections.length && onFilesRejected) {
            onFilesRejected(fileRejections);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles.length, fileRejections.length]);
    return (React.createElement("div", null,
        React.createElement(Visible, { when: showProcessingFlow },
            React.createElement(ProcessingZoneContainer, __assign({}, __assign(__assign({}, processingConfig), { files: files })))),
        React.createElement(Visible, { when: !showProcessingFlow },
            React.createElement(UploadDropzoneComponent, { type: type, dropzoneClass: dropzoneClass, fileBrowseTitle: fileBrowseTitle, dragDropTitle: dragDropTitle, classes: classes, getRootProps: getRootProps, getInputProps: getInputProps, open: open, disabled: disabled }))));
};

export { UploadDropzoneContainer as default };
//# sourceMappingURL=UploadDropzoneContainer.js.map
